import * as Immutable from "immutable";
import * as ACTION_TYPES from "./action-types";

const MFA_REDUCER = (state = Immutable.Map(), action) => {
    switch (action.type) {
        case ACTION_TYPES.SAVE_MFA_OPTION:
            return state.set("option", action.value).set("required", true);
        case ACTION_TYPES.SAVE_MFA_REQUIRED:
            return state.set("required", action.value);
        default:
            return state;
    }
};

export { MFA_REDUCER };
